import React from 'react';
import VideoPlayer, { HLS_EXTENSIONS } from '@rsos/video';
import {
  AUDIO_URL,
  WEB_URL,
  IMAGE_URL,
  PHONE_NUMBER,
  PREFORMATTED,
  SAFE_IMAGE_URL,
} from '../formats';
import formatPhone from './helpers/formatPhone';

const handleImageUrl = data => {
  if (HLS_EXTENSIONS.test(data)) {
    return <VideoPlayer playerId={`video-${data}`} controls src={data} />;
  } else {
    return <img src={data} style={{ width: '100%' }} />;
  }
};

const formatString = (data, format) => {
  switch (format) {
    case WEB_URL:
      return (
        <a
          href={data}
          className="format-web-url"
          target="_blank"
          rel="noopener noreferrer"
        >
          {data}
        </a>
      );
    case IMAGE_URL:
      return handleImageUrl(data);
    case SAFE_IMAGE_URL:
      return handleImageUrl(data);
    case PHONE_NUMBER:
      return <>{formatPhone(data)}</>;
    case PREFORMATTED:
      return <pre>{JSON.stringify(data, null, 2)}</pre>;
    case AUDIO_URL:
      return (
        <audio
          controls
          src={data}
          preload="auto"
          className="format-audio-url"
        />
      );
    default:
      return <>{String(data)}</>;
  }
};

export default formatString;
